export const ZOOM_SUMMARY_STATUS = {
  in_progress: "IN_PROGRESS",
  completed: "COMPLETED",
  failed: "FAILED",
} as const;
